<template>
  <div>
    <div class="display-1 font-weight-bold pb-3">
      <span class="display-1 font-weight-bold">
        Смена заголовка хот-спота
      </span>
    </div>

    <div v-if="error" class="error--text pb-3 font-weight-medium">
      {{ error }}
    </div>

    <v-form
      ref="form"
      @keyup.native.enter="editHotspotName"
      @submit.prevent="() => false"
    >
      <label>Новый заголовок</label>
      <v-text-field
        v-model="hotspot.title"
        :rules="[rules.required]"
        height="42"
        solo
        placeholder="Введите заголовок"
      ></v-text-field>

      <v-btn @click="editHotspotName" class="primary mx-0 px-5">
        Изменить
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import Common from "../../modules/common";

export default {
  name: "HotspotEditName",

  data: () => ({
    error: false,
    rules: {
      required: v => !!v || "Поле обязательно для заполнения"
    }
  }),

  props: {
    // id хотспота
    id: {
      type: Number,
      required: true
    }
  },

  computed: {
    // объект с данными по хотспоту
    hotspot() {
      return this.$store.getters.getHotspot(this.id);
    }
  },

  methods: {
    /**
     * редактирует title хотспота
     */
    editHotspotName() {
      this.error = false;

      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("editHotspot", {
            id: this.hotspot.id,
            title: this.hotspot.title
          })
          .then(() => {
            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: "Хотспот успешно переименован"
            });
            this.$emit("closeDialog");
            // событие в метрике
            Common.sendMetrika("rename2");
          })
          .catch(err => {
            this.error = err;
          });
      }
    }
  }
};
</script>
